import { USER_ROLES } from "./enums.js";
const ALL = USER_ROLES;
const REVIEWERS = ["dueno", "contador"];
const OWNER = ["dueno"];
export const PERMISSIONS = {
    view: {
        label: "Ver empresas, comprobantes, contrapartes, libros y Caja IVA",
        roles: ALL,
    },
    writeVouchers: {
        label: "Cargar, editar, mover y borrar comprobantes en períodos abiertos",
        roles: ALL,
    },
    importFiles: {
        label: "Importar archivos de comprobantes a períodos abiertos",
        roles: ALL,
    },
    manageCounterparts: {
        label: "Confirmar contrapartes y corregir su nombre o condición de IVA",
        roles: ALL,
    },
    // Martín, 2026-10-06: the Operador does not see Asistentes; 2026-10-20: neither does the
    // Contador. Enforced on the OAuth approval, the token endpoint and every MCP request, so a
    // demoted user loses the connection at once.
    connectAssistant: {
        label: "Conectar un asistente de IA, que trabaja con el rol de quien lo conecta",
        roles: OWNER,
    },
    writeVouchersInReview: {
        label: "Cargar, editar, mover, borrar e importar comprobantes en períodos en revisión",
        roles: REVIEWERS,
    },
    calculateVatPosition: { label: "Calcular y guardar la Caja IVA", roles: REVIEWERS },
    changePeriodStatus: {
        label: "Pasar períodos a revisión, cerrarlos y marcarlos presentados",
        roles: REVIEWERS,
    },
    createCompanies: { label: "Dar de alta empresas", roles: REVIEWERS },
    // Martín, 2026-10-20: only the Dueño sees the audit trail.
    viewAudit: { label: "Consultar y exportar la auditoría", roles: OWNER },
    reopenPeriod: { label: "Reabrir un período cerrado", roles: OWNER },
    manageUsers: {
        label: "Dar de alta usuarios, cambiarles el rol y desactivarlos",
        roles: OWNER,
    },
    editBranding: { label: "Editar la marca del estudio", roles: OWNER },
    manageCompanyContacts: {
        label: "Cargar y editar los contactos de las empresas",
        roles: REVIEWERS,
    },
    manageReceivables: {
        label: "Ver y registrar cobranzas: cuentas corrientes, cargos, cobros, abonos y tablero",
        roles: OWNER,
    },
    sendDocuments: { label: "Mandar documentos por mail a las empresas", roles: OWNER },
    importTaxAccounts: {
        label: "Ver e importar las cuentas tributarias (Sistema de Cuentas Tributarias de ARCA)",
        roles: ALL,
    },
    manageTaxAccounts: {
        label: "Registrar una consulta de cuentas tributarias sin deuda y eliminar consultas",
        roles: REVIEWERS,
    },
    managePaymentPlans: {
        label: "Archivar planes de pago y editar las personas asociadas a una empresa",
        roles: REVIEWERS,
    },
};
export function can(role, permission) {
    return PERMISSIONS[permission].roles.includes(role);
}
//# sourceMappingURL=permissions.js.map